import $ from 'jquery';

$('.press_tab').click(function () {
  const cat = $(this).data('cat');
  const type = $(this).data('type');
  const isCurrentActive = $(this).hasClass('active');

  $(this).toggleClass('active', !isCurrentActive);

  const isGlobalActive = $('.press_tab').hasClass('active');

  $(`.press_list--${type}`).toggleClass('filtered', isGlobalActive);

  $(`.press_item--${type}[data-cat="${cat}"]`)
    .toggleClass('active', !isCurrentActive)
    .removeClass('visible');

  $(`.press_item--${type}.active`)
    .removeClass('visible')
    //.slice(0, 3)
    .addClass('visible');
});

$('.press_button--media').click(function () {
  const isActive = $(this).hasClass('active');
  $(this).toggleClass('active');
  $('span', this).text(isActive ? 'Load more' : 'Show less');
  $('.press_list--media').toggleClass('showall');
});
